import React, { useCallback, useMemo, useRef, useState } from 'react';
//import moment from 'moment';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { RoundAddButton, ScopeButton } from '@monorepo/shared-lib';
import { InputNumber, Select, Space, Switch, Tooltip } from 'antd';
import { ScopeCheckbox } from 'components/Custom/checkbox';
import { ReverseCharge, SelectedRate } from 'pages/returns';
import { Section, TaxRate } from 'store/returns/models/returnData';
import styled from 'styled-components';

import { StyledPopconfirm } from 'components/Custom/Popconfirm';
import { useTranslation } from 'react-i18next';
import { TaxRateType } from 'store/app/enums';
import {
  TifdActivityDraft,
  readTifdActivityDrafts,
  tifdActivitySaveBlock,
  tifdActivityText,
} from 'store/returns/models/mappingTaxRate';

const SidePanelWrapper = styled.div`
  font-family: var(--font-family, Inter, sans-serif);
  padding: 0 10px 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  height: 100%;

  .control-box,
  .control-box-small {
    margin-top: 14px;
    background: var(--color-surface-raised, #ffffff);
    width: 400px;
    border-top: 1px solid var(--color-border, #dbeae3);
    border-left: 1px solid var(--color-border, #dbeae3);
    border-right: 1px solid var(--color-border, #dbeae3);
    border-radius: 10px 10px 0px 0px;
    padding: 15px 22px 0 22px;
    box-shadow: 0px 5px 10px 0px #0000000d;
    //box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;
    z-index: 10;
  }

  .control-box-small {
    border-radius: 10px;
  }

  .control-box-no-shadow {
    box-shadow: none;
  }
  .control-line-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    color: #41aaaf;
    margin-bottom: 15px;
  }

  .mapping-ignored-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex: 0 0 auto;
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: var(--color-text-base, #2e2e2e);
    white-space: nowrap;
  }

  .mapping-ignored-toggle .ant-switch {
    pointer-events: none;
  }

  .mapping-list-box {
    background: var(--color-surface-raised, #ffffff);
    width: 400px;
    border-left: 1px solid var(--color-border, #dbeae3);
    border-right: 1px solid var(--color-border, #dbeae3);
    padding: 0px 22px;
    z-index: 0;
    overflow: hidden;
  }

  .bottom-box {
    background: var(--color-surface-raised, #ffffff);
    height: 22px;
    width: 400px;
    border-radius: 0px 0px 10px 10px;
    border-bottom: 1px solid var(--color-border, #dbeae3);
    border-left: 1px solid var(--color-border, #dbeae3);
    border-right: 1px solid var(--color-border, #dbeae3);
    //padding: 0px 22px;
    z-index: 10;
    box-shadow: 0px -5px 10px 0px #0000000d;
  }
  .bottom-box-no-shadow {
    box-shadow: none;
  }

  .control-line {
    border-top: 1px solid var(--color-border, #dbeae3);
    width: 100%;
    margin-bottom: 15px;
  }

  .mapping-details {
    font-size: 12px;
    line-height: 20px;
    text-align: left;
  }

  .tag-cash,
  .tag-reverse,
  .tags-all,
  .tag-OOS,
  .tag-OTHER {
    align-self: center;
    //width:100px
    height: 21px;
    border-radius: 2px;
    border: 1px solid var(--color-border, #dbeae3);
    opacity: 0px;
    background: var(--color-status-warning-bg, #fff5e2);
    font-size: 12px;
    font-weight: 600;
    color: var(--color-text-dark, #042a2a);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 3px;
    margin: 1px 2px;
    z-index: 2;
    white-space: nowrap;
  }

  html[data-theme='dark'] & .tag-cash,
  html[data-theme='dark'] & .tag-reverse,
  html[data-theme='dark'] & .tags-all,
  html[data-theme='dark'] & .tag-OOS,
  html[data-theme='dark'] & .tag-OTHER {
    color: var(--color-text-base, #e3eaeb);
  }

  .tag-OOS {
    background: var(--color-status-danger-bg, #fce7e7);
  }

  .tag-OTHER {
    background: var(--color-status-info-bg, #e1edf6);
  }

  .tag-cash {
    background: var(--color-border, #dbeae3);
  }

  .tag-reverse {
    background: #ede5f7;
  }

  .cash-accounting-box {
    background: var(--color-surface-raised, #ffffff);
    //height: 22px;
    width: 400px;
    //border-radius: 0px 0px 10px 10px;
    border-bottom: 1px solid var(--color-border, #dbeae3);
    border-left: 1px solid var(--color-border, #dbeae3);
    border-right: 1px solid var(--color-border, #dbeae3);
    padding: 0px 20px;
    z-index: 10;
    //box-shadow: 0px -5px 10px 0px #0000000d;
  }

  .bottom-box-ca {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 12px 20px;
  }
  .checkbox-rc-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 20px;
  }

  .checkbox-rc {
    display: flex;
    gap: 10px;
    align-content: center;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }
  .ant-input-number-input-wrap {
    font-size: 12px;
  }
  .ant-input-number-group-addon {
    padding: 0 5px;
  }
`;

interface SidePanelProps {
  selectedRates: SelectedRate[];
  selectedRatesCopy: SelectedRate[];
  reverseCharges: ReverseCharge[];
  taxRates?: TaxRate[];
  outOfScopeCode: string;
  handleCashAccounting: (rateId?: string) => void;
  handleReverseCharge: (rateId: string, value: string | null) => void;
  hasCashAccounting: boolean;
  saveCashAccounting: () => void;
  saveReverseCharges: () => boolean;
  fillCashAccounting: (value: boolean) => void;
  resetReverseCharge: () => void;
  loadCashAccounting: () => void;
  useCashAccounting: boolean;
  toggleCA: (value: boolean) => void;
  useReverseCharge: boolean;
  toggleRC: (value: boolean) => void;
  loadReverseCharge: () => void;
  updateTaxRateType: (type: TaxRateType, rateId: string) => void;
  resetForm: () => void;
  useCashReverse: boolean;
  onSubmit: () => void;
  providerName?: string;
  saving?: boolean;
  includeCashAndReverseCharge?: boolean;
  /** Malta TIFD does not show the input/output arrows. */
  includeInputOutput?: boolean;
  ratesListTitle?: string;
  /** When set, Save checks the activity rows written as the user types. */
  validateActivities?: boolean;
  onActivityWarning?: (block: 'required' | 'empty') => void;
  /** Malta TIFD chart list hides Ignore rows until the user shows them. */
  hideIgnoredAccounts?: boolean;
  sections?: Section[];
  tifdActivities?: TifdActivityDraft[];
  accountExtras?: Record<
    string,
    { creditBalanceCode: string | null; activityKey: string | null }
  >;
  onCreditBalanceCodeChange?: (accountId: string, code: string | null) => void;
  onAccountActivityChange?: (accountId: string, activityKey: string) => void;
}
type TaxRateMappingRowProps = {
  taxRate: TaxRate;
  selectedRate?: SelectedRate;
  outOfScopeCode: string;
  showInputOutput: boolean;
  onToggleTaxRateType: (type: TaxRateType, rateId: string) => void;
  sheet?: 'BALANCE_SHEET' | 'INCOME';
  creditValue?: string | null;
  activityKey?: string | null;
  creditOptions?: {
    label?: string;
    value?: string;
    options?: { value: string; label: string }[];
  }[];
  activityOptions?: { value: string; label: string }[];
  onCreditChange?: (accountId: string, code: string | null) => void;
  onActivityChange?: (accountId: string, activityKey: string) => void;
};

const TaxRateMappingRow = React.memo(function TaxRateMappingRow({
  taxRate,
  selectedRate,
  outOfScopeCode,
  showInputOutput,
  onToggleTaxRateType,
  sheet,
  creditValue,
  activityKey,
  creditOptions,
  activityOptions,
  onCreditChange,
  onActivityChange,
}: TaxRateMappingRowProps) {
  const { t } = useTranslation();
  const showIoToggle =
    showInputOutput &&
    !!selectedRate &&
    selectedRate.location[0] !== outOfScopeCode &&
    selectedRate.location?.[0]?.toUpperCase() !== 'OTHER' &&
    selectedRate.location.length > 0;
  const accountId = String(taxRate.taxType);
  const activityValue =
    activityOptions?.some((option) => option.value === activityKey)
      ? activityKey
      : activityOptions?.[0]?.value;
  const showCredit = sheet === 'BALANCE_SHEET' && !!onCreditChange;
  const showActivity =
    sheet === 'INCOME' && !!onActivityChange && (activityOptions?.length ?? 0) > 0;

  const mapped = !!selectedRate?.location?.some(Boolean);
  const assigned = sheet === 'BALANCE_SHEET' || sheet === 'INCOME';

  return (
    <div
      className={
        'scope-mapping-list-row' +
        (mapped ? ' scope-mapping-list-row--mapped' : '') +
        (assigned ? ' scope-mapping-list-row--assigned' : '')
      }
    >
      <div className="scope-mapping-list-name">
        <span className="scope-truncate" title={taxRate.name}>
          {taxRate.name}
        </span>
      </div>
      <div className="scope-mapping-list-codes">
        {selectedRate?.location.map((l) => (
          <div
            key={l}
            className={
              l === outOfScopeCode
                ? 'tag-OOS'
                : l?.toUpperCase() === 'OTHER'
                ? 'tag-OTHER'
                : 'tags-all'
            }
          >
            {l}
          </div>
        ))}
        {selectedRate?.cashAccounting && (
          <div className="tag-cash">
            {t('returns.mapping.side-panel.cash-tag')}
          </div>
        )}
        {selectedRate?.reverseCharge && selectedRate.reverseCharge > 0 && (
          <div className="tag-reverse">
            {t('returns.mapping.side-panel.reverse-charge-tag')}
          </div>
        )}
      </div>
      {showIoToggle ? (
        <div>
          <Tooltip
            title={t('returns.mapping.side-panel.toggle-input-output-tooltip')}
          >
            {selectedRate?.taxRateType === TaxRateType.INPUT && (
              <ArrowLeftOutlined
                style={{ color: '#3c7edb' }}
                onClick={() =>
                  onToggleTaxRateType(TaxRateType.OUTPUT, taxRate.taxType)
                }
              />
            )}{' '}
            {selectedRate?.taxRateType === TaxRateType.OUTPUT && (
              <ArrowRightOutlined
                style={{ color: 'var(--color-primary, #41aaaf)' }}
                onClick={() =>
                  onToggleTaxRateType(TaxRateType.INPUT, taxRate.taxType)
                }
              />
            )}
          </Tooltip>
        </div>
      ) : null}
      {showCredit ? (
        <div className="scope-mapping-list-extra">
          <span>{t('returns.mapping.side-panel.if-credit')}</span>
          <Select
            size="small"
            showSearch
            optionFilterProp="label"
            popupMatchSelectWidth={false}
            classNames={{ popup: { root: 'scope-mapping-list-select-dropdown' } }}
            value={creditValue ?? ''}
            options={creditOptions}
            onChange={(value) => onCreditChange(accountId, value || null)}
          />
        </div>
      ) : null}
      {showActivity ? (
        <div className="scope-mapping-list-extra">
          <span>{t('returns.mapping.side-panel.activity')}</span>
          <Select
            size="small"
            disabled={(activityOptions?.length ?? 0) <= 1}
            popupMatchSelectWidth={false}
            classNames={{ popup: { root: 'scope-mapping-list-select-dropdown' } }}
            value={activityValue}
            options={activityOptions}
            onChange={(value) => onActivityChange(accountId, value)}
          />
        </div>
      ) : null}
    </div>
  );
});

export const SidePanel: React.FC<SidePanelProps> = React.memo(
  ({
    selectedRates,
    selectedRatesCopy,
    reverseCharges,
    taxRates,
    outOfScopeCode,
    handleCashAccounting,
    handleReverseCharge,
    hasCashAccounting,
    saveCashAccounting,
    saveReverseCharges,
    fillCashAccounting,
    resetReverseCharge,
    loadCashAccounting,
    loadReverseCharge,
    useCashAccounting,
    toggleCA,
    useReverseCharge,
    toggleRC,
    updateTaxRateType,
    resetForm,
    useCashReverse,
    onSubmit,
    providerName,
    saving,
    includeCashAndReverseCharge = true,
    includeInputOutput = true,
    ratesListTitle,
    validateActivities = false,
    onActivityWarning,
    hideIgnoredAccounts = false,
    sections,
    tifdActivities,
    accountExtras,
    onCreditBalanceCodeChange,
    onAccountActivityChange,
  }) => {
    const { t } = useTranslation();
    const listTitle =
      ratesListTitle ?? t('returns.mapping.side-panel.tax-rate-mapping');

    const [bottom, setBottom] = useState<boolean>(false);
    const [top, setTop] = useState<boolean>(true);
    const [showIgnored, setShowIgnored] = useState(false);

    const selectedRateById = useMemo(() => {
      const map = new Map<string, SelectedRate>();
      selectedRates?.forEach((sr) => {
        if (sr?.value == null) return;
        map.set(String(sr.value), sr);
      });
      return map;
    }, [selectedRates]);

    const isIgnoredAccount = useCallback(
      (taxRate: TaxRate) => {
        const selected =
          selectedRateById.get(String(taxRate.taxType)) ??
          selectedRateById.get(String(taxRate.id));
        return (
          selected?.location?.some(
            (code) => code?.trim().toLowerCase() === 'ignore'
          ) ?? false
        );
      },
      [selectedRateById]
    );

    const hiddenIgnoredCount = useMemo(() => {
      if (!hideIgnoredAccounts || !taxRates) return 0;
      return taxRates.filter((taxRate) => isIgnoredAccount(taxRate)).length;
    }, [hideIgnoredAccounts, isIgnoredAccount, taxRates]);

    const visibleTaxRates = useMemo(() => {
      if (!taxRates) return [];
      if (!hideIgnoredAccounts || showIgnored) return taxRates;
      return taxRates.filter((taxRate) => !isIgnoredAccount(taxRate));
    }, [hideIgnoredAccounts, isIgnoredAccount, showIgnored, taxRates]);

    const sheetByCode = useMemo(() => {
      const map = new Map<string, 'BALANCE_SHEET' | 'INCOME'>();
      sections?.forEach((section) => {
        if (section.sheet !== 'BALANCE_SHEET' && section.sheet !== 'INCOME') {
          return;
        }
        section.subsections?.forEach((subsection) => {
          if (!subsection.outOfScope) {
            map.set(subsection.code, section.sheet as 'BALANCE_SHEET' | 'INCOME');
          }
        });
      });
      return map;
    }, [sections]);

    const creditOptions = useMemo(() => {
      const sheetLabel = (sheet?: string) => {
        if (sheet === 'BALANCE_SHEET') {
          return t('returns.mapping.sheet-balance-sheet');
        }
        if (sheet === 'INCOME') return t('returns.mapping.sheet-income');
        return '';
      };
      const groups = (sections ?? [])
        .slice()
        .sort((left, right) => left.sortOrder - right.sortOrder)
        .flatMap((section) => {
          const label = sheetLabel(section.sheet);
          if (!label) return [];
          const options = (section.subsections ?? [])
            .filter((subsection) => !subsection.outOfScope)
            .slice()
            .sort((left, right) => left.sortOrder - right.sortOrder)
            .map((subsection) => ({
              value: subsection.code,
              label: `${subsection.code} ${subsection.name}`,
            }));
          if (!options.length) return [];
          return [{ label: `${label} · ${section.name}`, options }];
        });
      return [
        { value: '', label: t('returns.mapping.side-panel.same-line') },
        ...groups,
      ];
    }, [sections, t]);

    const activityOptions = useMemo(
      () =>
        (tifdActivities ?? []).map((activity, index) => ({
          value: activity.key,
          label: `${index + 1} · ${
            tifdActivityText(activity.establishmentName) ||
            t('returns.mapping.activity-option-fallback', { n: index + 1 })
          }`,
        })),
      [tifdActivities, t]
    );

    const onCACheckboxClick = (rateId?: string) => {
      handleCashAccounting(rateId);
    };

    const onRCCheckboxClick = (rateId?: string) => {
      rateId && handleReverseCharge(rateId, null);
    };

    const onRCChange = (rateId: string, value: string) => {
      handleReverseCharge(rateId, value);
    };

    const handleSaveCA = () => {
      saveCashAccounting();
      toggleCA(false);
    };

    const handleSaveRC = () => {
      const succesfullSave = saveReverseCharges();
      succesfullSave && toggleRC(false);
    };

    const handleClearCA = () => {
      fillCashAccounting(false);
    };

    const handleClearRC = () => {
      resetReverseCharge();
    };

    const handleSelectAllCA = () => {
      fillCashAccounting(true);
    };

    const onCAClick = () => {
      !useCashAccounting && loadCashAccounting();
      toggleCA(!useCashAccounting);
    };

    const onRCClick = () => {
      !useReverseCharge && loadReverseCharge();
      toggleRC(!useReverseCharge);
    };

    const updateTaxRateTypeRef = useRef(updateTaxRateType);
    updateTaxRateTypeRef.current = updateTaxRateType;
    const onToggleTaxRateType = useCallback(
      (type: TaxRateType, rateId: string) => {
        updateTaxRateTypeRef.current(type, rateId);
      },
      []
    );

    const getCACheckbox = (taxRate: TaxRate) => {
      const selRate = selectedRatesCopy?.find(
        (sr) => sr.value === taxRate.taxType
      );
      const enableCA =
        useCashAccounting &&
        selRate?.location &&
        selRate.location.length > 0 &&
        selRate?.location[0] !== outOfScopeCode &&
        selRate?.location?.[0]?.toUpperCase() !== 'OTHER';

      if (enableCA || true)
        return (
          <>
            <ScopeCheckbox
              checked={selRate?.cashAccounting}
              value={selRate?.cashAccounting}
              onChange={() => onCACheckboxClick(selRate?.value)}
              name={selRate?.value}
              aria-label={`${taxRate.name} [${taxRate.taxRate}%]`}
            >
              {selRate?.cashAccounting ? (
                <strong>{`${taxRate.name} [${taxRate.taxRate}%]`}</strong>
              ) : (
                taxRate.name + ' [' + taxRate.taxRate + '%]'
              )}
            </ScopeCheckbox>
          </>
        );
    };

    const getRCCheckbox = (taxRate: TaxRate) => {
      const selRate = reverseCharges?.find(
        (rc) => rc.rateId === taxRate.taxType
      );

      return (
        <div className="checkbox-rc-wrapper">
          <div className="checkbox-rc">
            <ScopeCheckbox
              checked={selRate?.used}
              value={selRate?.used}
              onChange={() => onRCCheckboxClick(selRate?.rateId)}
              aria-label={taxRate.name}
            />
            <span
              className="scope-truncate"
              title={taxRate.name}
              style={{
                fontSize: 12,
                color: 'var(--color-text-muted, #5a6a6a)',
                width: 200,
              }}
            >
              {selRate?.used ? <strong>{taxRate.name}</strong> : taxRate.name}
            </span>
          </div>
          {selRate?.used && (
            <>
              <InputNumber<string>
                style={{ width: 80, fontSize: '12px' }}
                defaultValue=""
                min="0"
                max="100"
                step="0"
                aria-label={`${taxRate.name} ${t(
                  'transactions.reverse-charge-amount'
                )}`}
                onChange={(val) => val && onRCChange(selRate.rateId, val)}
                onStep={(val) => val && onRCChange(selRate.rateId, val)}
                stringMode
                size={'small'}
                addonAfter="%"
                value={selRate.amount !== null ? String(selRate.amount) : ''}
              />
            </>
          )}
        </div>
      );
    };

    const handleScroll = (e) => {
      const bottom =
        e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
      const top = e.target.scrollTop === 0;
      if (bottom) {
        setBottom(true);
        setTop(false);
      } else if (top) {
        setBottom(false);
        setTop(true);
      } else {
        setBottom(false);
        setTop(false);
      }
    };

    return (
      <SidePanelWrapper>
        {includeCashAndReverseCharge && (
          <div
            className={`control-box ${
              !useReverseCharge && 'control-box-small'
            }`}
          >
            <div className="control-line-box">
              <span>
                {t('returns.mapping.side-panel.calculate-reverse-charges')}
              </span>
              <RoundAddButton disabled={useCashAccounting} onClick={onRCClick}>
                {useReverseCharge ? '-' : '+'}
              </RoundAddButton>
            </div>
          </div>
        )}
        {includeCashAndReverseCharge && useReverseCharge ? (
          <>
            <div className={'cash-accounting-box'}>
              <div className="mapping-details" style={{ width: '95%' }}>
                {t(
                  'returns.mapping.side-panel.reverse-charge-description-before'
                )}{' '}
                <strong>
                  {t('returns.mapping.side-panel.reverse-charge-do-not')}
                </strong>{' '}
                {t(
                  'returns.mapping.side-panel.reverse-charge-description-after-do-not',
                  {
                    providerName:
                      providerName ||
                      t('returns.mapping.side-panel.accounting-software'),
                  }
                )}
              </div>
              <div className="divider-10" />
              <div
                className="scroller-rc"
                tabIndex={0}
                role="region"
                aria-label={t(
                  'returns.mapping.side-panel.calculate-reverse-charges'
                )}
              >
                {taxRates?.map((tr) => (
                  <>
                    {tr.taxRate === 0 && (
                      <div style={{ margin: '7px 0px' }}>
                        {getRCCheckbox(tr)}
                      </div>
                    )}
                  </>
                ))}
              </div>
            </div>

            <div className={`bottom-box bottom-box-no-shadow bottom-box-ca`}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <ScopeButton //@ts-ignore
                  width="88px"
                  height="25px"
                  type="default"
                  fontSize="12px"
                  lineheight="12px"
                  onClick={handleClearRC}
                >
                  {t('common.clear')}
                </ScopeButton>

                <ScopeButton //@ts-ignore
                  width="88px"
                  height="25px"
                  type="primary"
                  fontSize="12px"
                  lineheight="12px"
                  onClick={handleSaveRC}
                >
                  {t('common.update')}
                </ScopeButton>
              </div>
            </div>
          </>
        ) : (
          <>
            {includeCashAndReverseCharge && (
              <div
                className={`control-box ${
                  !useCashAccounting && 'control-box-small'
                }`}
              >
                <div className="control-line-box">
                  <span>
                    {t('returns.mapping.side-panel.enable-cash-accounting')}
                  </span>
                  <RoundAddButton
                    disabled={!hasCashAccounting}
                    onClick={onCAClick}
                  >
                    {useCashAccounting ? '-' : '+'}
                  </RoundAddButton>
                </div>
              </div>
            )}

            {includeCashAndReverseCharge && useCashAccounting ? (
              <>
                <div className={'cash-accounting-box'}>
                  <div className="mapping-details" style={{ width: '95%' }}>
                    {t(
                      'returns.mapping.side-panel.cash-accounting-description'
                    )}
                  </div>
                  <div className="divider-10" />
                  <div
                    className="scroller-ca"
                    tabIndex={0}
                    role="region"
                    aria-label={t(
                      'returns.mapping.side-panel.enable-cash-accounting'
                    )}
                  >
                    {taxRates?.map((tr) => (
                      <div style={{ margin: '7px 0px' }}>
                        {getCACheckbox(tr)}
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className={`bottom-box bottom-box-no-shadow bottom-box-ca`}
                >
                  <div style={{ display: 'flex', gap: 10 }}>
                    <ScopeButton //@ts-ignore
                      width="88px"
                      height="25px"
                      type="default"
                      fontSize="12px"
                      lineheight="12px"
                      onClick={handleSelectAllCA}
                    >
                      {t('common.select-all')}
                    </ScopeButton>
                    <ScopeButton //@ts-ignore
                      width="88px"
                      height="25px"
                      type="default"
                      fontSize="12px"
                      lineheight="12px"
                      onClick={handleClearCA}
                    >
                      {t('common.clear')}
                    </ScopeButton>
                  </div>
                  <ScopeButton //@ts-ignore
                    width="88px"
                    height="25px"
                    type="primary"
                    fontSize="12px"
                    lineheight="12px"
                    onClick={handleSaveCA}
                  >
                    {t('common.update')}
                  </ScopeButton>
                </div>
              </>
            ) : (
              <>
                <div
                  className={`control-box ${
                    top ? 'control-box-no-shadow' : ''
                  }`}
                >
                  <div className="control-line-box">
                    <span style={{ color: '#41aaaf !important' }}>
                      {listTitle}
                    </span>
                    {hideIgnoredAccounts ? (
                      <button
                        type="button"
                        className="mapping-ignored-toggle"
                        aria-pressed={showIgnored}
                        onClick={() => setShowIgnored((current) => !current)}
                      >
                        <Switch
                          size="small"
                          checked={showIgnored}
                          tabIndex={-1}
                        />
                        <span>
                          {showIgnored
                            ? t('returns.mapping.side-panel.hide-unused', {
                                count: hiddenIgnoredCount,
                              })
                            : t('returns.mapping.side-panel.show-hidden', {
                                count: hiddenIgnoredCount,
                              })}
                        </span>
                      </button>
                    ) : null}
                  </div>
                </div>
                <div className="mapping-list-box">
                  <div
                    id="scrollable"
                    className={
                      includeCashAndReverseCharge
                        ? 'scroller'
                        : 'scroller scroller--accounts'
                    }
                    onScroll={handleScroll}
                    tabIndex={0}
                    role="region"
                    aria-label={listTitle}
                  >
                    {visibleTaxRates.map((tr) => {
                      const selected =
                        selectedRateById.get(String(tr.taxType)) ??
                        selectedRateById.get(String(tr.id));
                      const boxCode = selected?.location?.find(Boolean);
                      const extra = accountExtras?.[String(tr.taxType)];
                      return (
                        <TaxRateMappingRow
                          key={tr.id}
                          taxRate={tr}
                          selectedRate={selected}
                          outOfScopeCode={outOfScopeCode}
                          showInputOutput={includeInputOutput}
                          onToggleTaxRateType={onToggleTaxRateType}
                          sheet={boxCode ? sheetByCode.get(boxCode) : undefined}
                          creditValue={extra?.creditBalanceCode}
                          activityKey={extra?.activityKey}
                          creditOptions={creditOptions}
                          activityOptions={activityOptions}
                          onCreditChange={onCreditBalanceCodeChange}
                          onActivityChange={onAccountActivityChange}
                        />
                      );
                    })}
                  </div>
                </div>
                <div
                  className={`bottom-box ${
                    bottom ? 'bottom-box-no-shadow' : ''
                  }`}
                />
                <div className="mapping-side-actions">
                  <div className="divider-10" />
                  <Space size={'small'}>
                  <StyledPopconfirm // @ts-ignore
                    placement="left"
                    title={t('returns.mapping.side-panel.reset-form-title')}
                    description={t(
                      'returns.mapping.side-panel.reset-form-description'
                    )}
                    okText={t('common.yes')}
                    cancelText={t('common.no')}
                    onConfirm={resetForm}
                  >
                    <ScopeButton
                      type="default" //@ts-ignore
                      //width="100%"
                      disabled={useCashReverse}
                      width="190px"
                      bg_color="var(--color-surface, #f3f7f8)"
                    >
                      {t('common.reset')}
                    </ScopeButton>
                  </StyledPopconfirm>

                  <ScopeButton
                    onClick={() => {
                      if (validateActivities) {
                        const block = tifdActivitySaveBlock(
                          readTifdActivityDrafts()
                        );
                        if (block) {
                          onActivityWarning?.(block);
                          return;
                        }
                      }
                      onSubmit();
                    }}
                    type="primary" //@ts-ignore
                    width="190px"
                    disabled={useCashReverse || saving}
                  >
                    {t('common.save')}
                  </ScopeButton>
                </Space>
                </div>
              </>
            )}
          </>
        )}
      </SidePanelWrapper>
    );
  }
);

SidePanel.displayName = 'SidePanel';
